// @ts-nocheck
import { formatDob } from '../utils/date';
import { formatPhoneWithDash } from '../utils/phone';
import { GroupType } from './enums';

export default function (store, { host }) {
  const Patient = store.defineModel('patient', {
    replaceKeys: {
      patientMrn: 'mrn',
      patientGender: 'gender',
      patientDob: 'dob',
    },

    parseAttrs(attrs) {
      if ('featureService' in attrs) delete attrs['featureService'];

      if ('patientContacts' in attrs) delete attrs['patientContacts'];

      if ('isPatientContact' in attrs) delete attrs['isPatientContact'];

      if ('dob' in attrs) {
        attrs.dob = formatDob(attrs.dob);
      }

      if ('phoneNumber' in attrs) {
        attrs.phoneNumber = formatPhoneWithDash(attrs.phoneNumber);
      }

      return attrs;
    },

    relations: {
      belongsTo: {
        user: { type: 'user', foreignKey: 'userId' },
      },
      hasMany: {
        contacts: { type: 'patientContact', foreignKey: 'patientId' },
        sharedConversations: {
          type: 'conversation',
          foreignKey: 'patientId',
          filter: (conversation, patient) => {
            const { counterParty } = conversation;
            if (!counterParty) return false;

            const { groupType, hasCurrentUserOrRole, memberIds } = counterParty;
            if (
              groupType === GroupType.PATIENT_MESSAGING &&
              hasCurrentUserOrRole &&
              memberIds.includes(patient.userId)
            ) {
              return true;
            }

            return false;
          },
          sortBy: [
            ['highestSortNumber', 'desc'],
            ['_origIndex', 'asc'],
            ['id', 'asc'],
          ],
        },
      },
    },
  });

  return Patient;
}
